/* lua.js generated code 0.3.0 */

var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var SettingPanelTip = xClass("SettingPanelTip", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/setting_panel_tips.csb")
})
SettingPanelTip.show = function (okCb) {
    let panel = SettingPanelTip.create(okCb)
    panel.popup(true)
}

SettingPanelTip.prototype.init = function (okCb) {
    var self = this
    self.okCb = okCb
    BasePanel.prototype.init.call(self)
    
    var btn = UIButton.create(self.getChild("btn_refresh"))
    btn.on(UIButtonEvent.Click, function () {
        self.onOKTapped()
    })
    ButtonPushBounceAnim.create(btn)

    if (_G.__level_effect == "LOW"){
        self.getChildByName("label_1").setString(getText("performance.tip.high.1"))
        self.getChildByName("label_2").setString(getText("performance.tip.high.2"))
    }else{
        self.getChildByName("label_1").setString(getText("performance.tip.low.1"))
        self.getChildByName("label_2").setString(getText("performance.tip.low.2"))
    }

    self.smoothDCSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    DCAssist.dc4SettingSmooth("quality_smooth_note_show", {
        session:self.smoothDCSession
    }) 
}

SettingPanelTip.prototype.onOKTapped = function () {
    var self = this
    DCAssist.dc4SettingSmooth("quality_smooth_note_click", {
        session:self.smoothDCSession
    }) 
    if (self.okCb){
        self.okCb()
    }
    self.onClose()
}

SettingPanelTip.prototype.popup = function () {
    var self = this
    // body
    var targetScale = self.getScale()
    self.setScale(0)
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var s = self.getContentSize()
    var pos = self.getAnchorPoint()
    var vSize = cc.Director.getInstance().getVisibleSize()
    var targetPos = cc.p((vSize.width - s.width) * 0.5 + s.width * pos.x, (vSize.height + s.height) * 0.5 + s.height * pos.y)
    self.setPosition(cc.p(vSize.width / 2, vSize.height / 2 - 80))
    var midPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 1.05)
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.25, 1.05 * targetScale), cc.MoveBy.create(0.25, midPoint))), cc.EaseSineIn.create(cc.Spawn.create(cc.ScaleTo.create(0.25, targetScale), cc.MoveTo.create(0.25, targetPos)))))
    return self
}
SettingPanelTip.prototype.fitResolution = function () {
    var self = this
    // body
}

module.exports = SettingPanelTip
